import type { ReactNode } from "react";
import { Slide, toast, ToastOptions } from "react-toastify";
import { Icons } from "@/assets/images";
import SuccessCheckIcon from "@/assets/images/success-icon.svg?react";
import { CustomToast, ToastBodyProps } from "./type";

export const SuccessIcon = (): React.ReactElement => {
  return <SuccessCheckIcon style={{ color: "var(--primary)" }} />;
};

export const ErrorIcon = (): React.ReactElement => {
  return <img src={Icons.dangerToastIcon} alt="error-icon" />;
};

const defaultOptions: ToastOptions = {
  position: "bottom-center",
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: false,
  pauseOnHover: false,
  draggable: false,
  theme: "light",
  transition: Slide,
};

const ToastBody = ({
  title,
  description,
  variant,
}: ToastBodyProps): React.ReactElement => (
  <>
    <p
      className={`font-semibold text-sm tracking-wide max-w-[290px] ${variant === "success" ? "text-primary" : "text-destructive"}`}
    >
      {title}
    </p>
    {description && (
      <p className="text-xs opacity-80 text-foreground max-w-[290px]">
        {description}
      </p>
    )}
  </>
);

export const showToast: CustomToast = {
  success: (
    message: ReactNode,
    description?: ReactNode,
    options?: ToastOptions,
  ) => {
    toast.success(
      <ToastBody title={message} description={description} variant="success" />,
      {
        ...defaultOptions,
        icon: <SuccessIcon />,
        ...options,
      },
    );
  },
  error: (
    message: ReactNode,
    description?: ReactNode,
    options?: ToastOptions,
  ) => {
    toast.error(
      <ToastBody title={message} description={description} variant="error" />,
      {
        ...defaultOptions,
        icon: <ErrorIcon />,
        ...options,
      },
    );
  },
};
